import script from "./InputTextWithSubmit.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputTextWithSubmit.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__